export const queryHomeSteps = [
    {
      element: ".FoterDetailContainer",
      intro: `
          <h3>Parent Features Bottom Pane</h3>
          <p>These are 4 Parents, each Parent has multiple features listed on the left most pane. Currently 'Digital.Class' parent is selected.</p>
        `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".Engagement",
      intro: `
          <h3>Engagement</h3>
          <p>Engagement has 2 features (as shown in left most pane):
         </p>
         <ol>
            <li>Community</li>
            <li>Query</li>
          </ol>
        `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".featuredLeftPaneE",
      intro: `
          <h3>Features Group Left Pane
          Engagement has 2 features as shown:</h3>
          <ol>
          <li>Community</li>
          <li>Query</li>
          </ol>
        `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".query",
      intro: `
          <h3>Query</h3>
          <p>Currently 'Query' feature is selected, Let's navigate through this feature</p>
        `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".queryGroups  ",
      intro: `
        <h3>Query Groups</h3>
        <p>You wll find all the query groups you are part of.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".prifilePic",
      intro: `
        <h3>Your profile, B4S App layout</h3>
        <p>Access your profile Information.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".done",
      intro: `
        <h3>Awesome, you are done. 😊</h3>
        <p>Click anywhere on the screen or click on the cross icon.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
  ]